export default __webpack_public_path__ + "static/media/36I-117164_-37343_0.a16f19ed.jpg";